import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'bi/feedback';

const biFeedbackService = {
  getBiFeedback: (id) => {
    return request({
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  saveBiFeedback: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteBiFeedBack: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default biFeedbackService;
